import {
  InitFigmaUploadRequestDto,
  InitFigmaUploadResponseDto,
} from "@swagger/typescript-fetch-goflyer";
import { adminApiService } from "../../utils/api";

export async function initFigmaUpload(
  file: File,
  token: string
): Promise<InitFigmaUploadResponseDto> {
  if (!/\.(fig|zip)$/i.test(file.name)) {
    throw new Error(
      "Invalid extension. Only .fig and .zip files are supported."
    );
  }

  const body: InitFigmaUploadRequestDto = {
    fileName: file.name,
    contentType: file.name.toLowerCase().endsWith(".zip")
      ? InitFigmaUploadRequestDto.ContentTypeEnum.Zip
      : InitFigmaUploadRequestDto.ContentTypeEnum.OctetStream,
    size: file.size,
  };

  try {
    const result =
      await adminApiService.gfFigmaTemplateDataAdminControllerInitFigmaUpload(
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

    return result as InitFigmaUploadResponseDto;
  } catch (error) {
    throw new Error(`Init upload failed: ${error}`);
  }
}

export async function uploadToS3(
  file: File,
  initResp: InitFigmaUploadResponseDto
): Promise<Response> {
  const formData = new FormData();

  if (initResp.fields && typeof initResp.fields === "object") {
    Object.keys(initResp.fields).forEach((key) => {
      formData.append(key, initResp.fields[key]);
    });
  }

  formData.append("file", file);

  console.log("FormData fields:", Object.keys(initResp.fields || {}));
  const response = await fetch(initResp.uploadUrl, {
    method: "POST",
    body: formData,
  });

  if (response.status === 204) {
    console.log("File uploaded successfully, no content returned");
  } else if (!response.ok) {
    throw new Error(
      `S3 upload failed: ${response.status} ${response.statusText}`
    );
  }

  return response;
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}
